module.exports = "pegasus/assets/blocks/column-1-theme5.png";